/* eslint-disable @typescript-eslint/no-var-requires */
const { palette } = require('./themes/nomad-spark/tokens').private;

/** @type {import('tailwindcss').Config} */
module.exports = {
  content: ['./src/**/*.{js,jsx,ts,tsx}'],
  theme: {
    extend: {
      screens: {
        desktop: '992px', // mobile / desktop breakpoint
      },
      backgroundImage: {
        'get-started-hero':
          'linear-gradient(90deg, #fff 63%, rgba(83, 179, 212, 0.1) 0)',
      },
      minHeight: {
        4: '1rem',
        5: '1.25rem',
        6: '1.5rem',
        8: '2rem',
        'full-after-header': 'calc(100vh - 107.5px)',
      },
      maxWidth: {
        50: '50%',
        45: '45%',
      },
      fontFamily: {
        'romek-rounded': 'RomekRounded, serif',
        'dm-sans': 'DMSans, sans-serif',
      },
      fontSize: {
        '5xl': '3.052rem',
        heading1: '',
      },
      borderRadius: {
        DEFAULT: '20px',
        xs: '16px',
        lg: '20px',
        '4xl': '2rem',
      },
      boxShadow: {
        DEFAULT: '0px 4px 15px 0px rgba(0, 0, 0, .1)',
        lg: '0px 4.126949787139893px 15.476061820983887px 0px rgba(0, 0, 0, 0.10)',
        hover: '0px 6px 8px 0px rgba(0, 0, 0, .25)',
      },
      colors: {
        primary: {
          DEFAULT: palette['nomad-poppy'].value,
          dark: palette['nomad-poppy-dark'].value,
          'extra-dark': palette['maroon'].value,
          'light-poppy': palette['button-red-ff521f'].value,
          light: palette['light-pink'].value,
          contrast: palette['white'].value,

          // TODO: REDESIGN: REMOVE
          // Ideally we dont need these, but they were added becasue an existing component uses these colors.
          //  If the component is not needed, remove theses
          // 'extra-dark': '#023A55', // hero-with-video
          'extra-light': '#F0F9FC', // hero-with-image, hero-with-side-image, hero-with-video
        },
        secondary: {
          DEFAULT: palette.black,
          light: palette['grey-30'],
          dark: palette['grey-80'],
          contrast: palette['white'].value,
        },
        typography: {
          DEFAULT: palette['text-body'],
          secondary: palette['nomad-poppy'],
          light: palette['text-muted'],

          // TODO: REDESIGN: REMOVE
          dark: '#03151b',
          'extra-light': 'rgba(255, 255, 255, 0.8)',
        },
        background: {
          DEFAULT: palette['background-default'].value,
          primary: '#53b3d41a',
        },
        maroon: {
          DEFAULT: palette.maroon.value,
          light: palette.maroonLight.value,
          dark: palette.maroonDark.value,
        },

        coral: palette['coral'].value,
        'light-blue': palette['light-blue'].value,
        'light-purple': palette['light-purple'].value,
        'lighter-purple': '#F8F8FF',
        sky: palette['sky'].value,
        orchid: palette['orchid'].value,
        'orchid-notification': palette['notification-orchid-f8f8ff'].value,
        indigo: palette['indigo'].value,
        ultraviolet: palette['ultraviolet'].value,

        grey50: palette['grey-5'].value,
        grey100: palette['grey-10'].value,
        grey200: palette['grey-10'].value,
        grey300: palette['grey-30'].value,
        grey400: palette['grey-30'].value,
        grey500: palette['grey-50'].value,
        grey600: palette['grey-60'].value,
        grey700: palette['grey-60'].value,
        grey800: palette['grey-80'].value,
        grey900: palette['grey-80'].value,
        greyA100: palette['grey-10'].value,
        greyA200: palette['grey-30'].value,
        greyA400: palette['grey-50'].value,
        greyA700: palette['grey-80'].value,
        'alt-gray': '#7D7C7C',

        error: {
          DEFAULT: palette.error.value,
          light: palette['notification-red-fff0eb'].value,
          dark: palette.error.value,
          contrast: palette.black.value,
        },
      },
      keyframes: {
        flicker: {
          '0%, 19.999%, 22%, 62.999%, 64%, 64.999%, 70%, 100%': {
            opacity: '0.99',
            filter:
              'drop-shadow(0 0 1px rgba(252, 211, 77)) drop-shadow(0 0 15px rgba(245, 158, 11)) drop-shadow(0 0 1px rgba(252, 211, 77))',
          },
          '20%, 21.999%, 63%, 63.999%, 65%, 69.999%': {
            opacity: '0.4',
            filter: 'none',
          },
        },
        shimmer: {
          '0%': {
            backgroundPosition: '-700px 0',
          },
          '100%': {
            backgroundPosition: '700px 0',
          },
        },
        fadeIn: {
          '0%': { opacity: 0, transform: 'translateY(5em)' },
          '100%': { opacity: 1, transform: 'translateY(0)' },
        },
        infiniteCarouselRightToLeft: {
          '0%': { transform: 'translateX(0)' },
          '100%': { transform: 'translateX(-100%)' },
        },
        infiniteCarouselLeftToRight: {
          '0%': { left: '-100%' },
          '100%': { left: '0%' },
        },
      },
      animation: {
        flicker: 'flicker 3s linear infinite',
        shimmer: 'shimmer 1.3s linear infinite',
        fadeIn: 'fadeIn .5s linear',
        infiniteCarouselRightToLeft:
          'infiniteCarouselRightToLeft var(--infinite-carousel-speed) linear infinite',
        infiniteCarouselLeftToRight:
          'infiniteCarouselLeftToRight var(--infinite-carousel-speed) linear infinite',
      },
    },
  },
  plugins: [
    require('@tailwindcss/forms'),
    require('@tailwindcss/typography'),
    require('@tailwindcss/aspect-ratio'),
  ],
};
